// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25U3i","icon":"styles_icon__3qCqo"};